import { render, staticRenderFns } from "./attached-tab.vue?vue&type=template&id=a7523a5c&"
import script from "./attached-tab.vue?vue&type=script&lang=js&"
export * from "./attached-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports